import { useEffect } from 'react';

import { useFetchData } from '@/api/apiHooks';
import { useReportContext } from '@/context/ReportContext';
import { usePanelInsightsFilters } from '@/hooks';
import { PanelDropDownItem } from '@/utils/types';
import { URLS } from '@/utils/urls';

interface UseFetchReportDataProps {
  url: (companyId, queryString) => string;
}

export const useFetchReportData = ({ url }: UseFetchReportDataProps) => {
  const { selectedCompany, setLastUpdatedAt, filters } = useReportContext();
  const { dataQueryString } = usePanelInsightsFilters();
  const { isLoading, data, error } = useFetchData<any>({
    url: url(selectedCompany, dataQueryString),
    enabled:
      !!selectedCompany &&
      !!dataQueryString &&
      !!filters?.selectedPanelsForComparison,
  });

  const { data: panelsData } = useFetchData<PanelDropDownItem[]>({
    url: URLS.getAllCompanyPanels(selectedCompany),
    enabled: !!selectedCompany,
    staleTime: 10 * 60 * 60 * 1000,
  });

  useEffect(() => {
    if (data) {
      setLastUpdatedAt(data?.last_updated_at);
    }
  }, [data, setLastUpdatedAt]);

  return {
    isLoading,
    data,
    error,
    panelsData,
  };
};
